import { queryClient } from 'queryClient';
import { MARKET_CART_DETAILS_QUERY_KEY } from './useDetails';

/**
 * Invalidates the React Query cart data.
 * Use this when Redux actions mutate the cart to keep React Query in sync.
 */
const invalidateCartQuery = () => {
	queryClient.invalidateQueries({
		queryKey: [MARKET_CART_DETAILS_QUERY_KEY],
	});
};

export default invalidateCartQuery;
